function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient",
  x1: 704.42,
  y1: 199.37,
  x2: -48.23,
  y2: 571.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e4e8f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#edf0f6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#fafbfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-2",
  x1: 236.86,
  y1: -483.71,
  x2: 284.61,
  y2: -483.71,
  gradientTransform: "matrix(1 0 0 -1 0 -149.41)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#adf37b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#78c864"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6",
  x1: 340.58,
  y1: 358.72,
  x2: 156.95,
  y2: 236.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#3d4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#454c5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#525b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#7e8fa7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#9cb1cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a3bad9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-2",
  x1: 360.03,
  y1: 329.5,
  x2: 176.4,
  y2: 207.27,
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-3",
  x1: 56.33,
  y1: 66.37,
  x2: 161.38,
  y2: 66.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a3bad9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#9cb1cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#7e8fa7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#525b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#454c5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#3d4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3a3f4c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-4",
  x1: 75.81,
  y1: 93.03,
  x2: 143.9,
  y2: 98.06,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-5",
  x1: 106.12,
  y1: 51.42,
  x2: 119.93,
  y2: 51.42,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-6",
  x1: 106.12,
  y1: 46.72,
  x2: 119.93,
  y2: 46.72,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-7",
  x1: 106.12,
  y1: 42.03,
  x2: 119.93,
  y2: 42.03,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-8",
  x1: 106.12,
  y1: 37.33,
  x2: 119.93,
  y2: 37.33,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-9",
  x1: 106.12,
  y1: 32.64,
  x2: 119.93,
  y2: 32.64,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-10",
  x1: 106.12,
  y1: 27.94,
  x2: 119.93,
  y2: 27.94,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-11",
  x1: 337.28,
  y1: 297.66,
  x2: 410.11,
  y2: 169.57,
  xlinkHref: "#develop-quickly_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-3",
  x1: 443.25,
  y1: 201.8,
  x2: 435.16,
  y2: 286.36,
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-4",
  x1: 442.95,
  y1: 201.77,
  x2: 434.86,
  y2: 286.33,
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-5",
  x1: -1076.8,
  y1: 155.65,
  x2: -1076.2,
  y2: 157.78,
  gradientTransform: "matrix(-12.96 7.84 -11.5 -19 -11754.71 11612.21)",
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-6",
  x1: 425.65,
  y1: 179.09,
  x2: 417.55,
  y2: 263.92,
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-7",
  x1: -984.16,
  y1: 200.01,
  x2: -985.75,
  y2: 201.37,
  gradientTransform: "matrix(-21.22 12.84 -10.07 -16.64 -18440.66 16186.09)",
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-12",
  x1: -974.02,
  y1: 201.34,
  x2: -975.06,
  y2: 201.85,
  gradientTransform: "matrix(-19.55 11.82 -9.18 -15.17 -16748.55 14785.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3a3f4c",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-13",
  x1: -137.03,
  y1: 320.95,
  x2: -133.13,
  y2: 321.84,
  gradientTransform: "matrix(-2.78 1.68 -.79 -1.31 -480.15 1212.73)",
  xlinkHref: "#develop-quickly_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-14",
  x1: 334.96,
  y1: 385.43,
  x2: 340.51,
  y2: 387.42,
  gradientTransform: "matrix(-1.96 1.18 -.87 -1.44 572.41 610.7)",
  xlinkHref: "#develop-quickly_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-15",
  x1: -429.24,
  y1: 275.04,
  x2: -426.46,
  y2: 275.8,
  gradientTransform: "matrix(-3.91 2.36 -1.33 -2.2 -1682.18 2148.48)",
  xlinkHref: "#develop-quickly_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_6-8",
  x1: 520.59,
  y1: 73.4,
  x2: 520.59,
  y2: 626.02,
  xlinkHref: "#develop-quickly_svg__New_Gradient_Swatch_6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-16",
  x1: 519.34,
  y1: 360,
  x2: 519.34,
  y2: 541.56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3a3f4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#3d4250"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#454c5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#525b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#657286"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#7e8fa7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#9cb1cf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-17",
  x1: 375.96,
  y1: -535.51,
  x2: 423.45,
  y2: -535.51,
  xlinkHref: "#develop-quickly_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-18",
  x1: 356.72,
  y1: -563.67,
  x2: 442.62,
  y2: -563.67,
  gradientTransform: "matrix(1 0 0 -1 0 -149.41)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#407de0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#285ad2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-19",
  x1: 209.25,
  y1: -535.51,
  x2: 312.13,
  y2: -535.51,
  gradientTransform: "matrix(1 0 0 -1 0 -149.41)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#28a086"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__linear-gradient-20",
  x1: 179.32,
  y1: -563.67,
  x2: 342.75,
  y2: -563.67,
  gradientTransform: "matrix(1 0 0 -1 0 -149.41)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#6e40aa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#503caa"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "develop-quickly_svg__New_Gradient_Swatch_7",
  x1: 309.71,
  y1: -602.07,
  x2: 309.71,
  y2: -575.08,
  gradientTransform: "matrix(1 0 0 -1 0 -149.41)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e4e9f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "develop-quickly_svg__radial-gradient",
  cx: 526.85,
  cy: 470.62,
  r: 7.39,
  gradientTransform: "translate(-150.14 -300.3)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "develop-quickly_svg__radial-gradient-2",
  cx: 526.85,
  cy: 490.68,
  r: 7.39,
  xlinkHref: "#develop-quickly_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "develop-quickly_svg__radial-gradient-3",
  cx: 526.85,
  cy: 510.75,
  r: 7.39,
  xlinkHref: "#develop-quickly_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("style", null, ".develop-quickly_svg__cls-25,.develop-quickly_svg__cls-31,.develop-quickly_svg__cls-32,.develop-quickly_svg__cls-33{fill-rule:evenodd}.develop-quickly_svg__cls-3{opacity:.67;mix-blend-mode:multiply}.develop-quickly_svg__cls-4{fill:#c9d2df}.develop-quickly_svg__cls-5{fill:#31353f}.develop-quickly_svg__cls-31,.develop-quickly_svg__cls-7{fill:#3a3f4c}.develop-quickly_svg__cls-25{fill:#fff}.develop-quickly_svg__cls-32{fill:#3eb883}.develop-quickly_svg__cls-33{fill:#7dc9a9}.develop-quickly_svg__cls-36{fill:#23c386}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "develop-quickly_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Path-2",
  d: "M556 172.61c80.73 33.89 110.15 152.08 28.57 222-72.62 62.24-252.48-3.33-347.76 51.95-95.1 55.19-153.75-171.83 53.27-134.56 98.2 17.64 137.29-193.39 265.92-139.39z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("image", {
  className: "develop-quickly_svg__cls-3",
  width: 294,
  height: 29,
  transform: "translate(12.08 277.09)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAScAAAAeCAYAAABuWNiQAAAACXBIWXMAAAsSAAALEgHS3X78AAADTklEQVR4Xu2d23HbMBBFLyX5Hac3N+EWXINbcBPuLYkfkiwxH8QGyyUg0U4m8QTnzOxAlMjh35mLJQh1fd8LAOCzsTh2AgDAv2B17ATP/cNjd+DnQ78BQBtUp2J3tzfvmqZ1c6Z1TkqdphJCSgBQwsul9+McUR2UU0FKsRQ+AwD0hbFUByVVlVMSk9XCjQt3HEVlICuAtogiMQHt3Vj6XBVUUU5OTF5Gy1BzJAUAbeGTkUlol8Y393nnzikKatIQL4hpmc47CeNKWVKlqR4AtEOcwpmAdhqktE31lkrpt85dO6L2tM7ktNQgoxNJZ5JO3Wjf+xRl1wJAe0QxmZQ2qdZpjI7Y3z88TtLTSE6F1GRJ6TzVRSo7joLyN0VSAG3gU5NN5UxMa0mvkl40eMKS0t5VMT2VkpMX1Eo5LV1K+iLpKtVF+t6meb4HBQBtEVOTielF0rOyI6KYrDE+EdSvhnhITUtNpXQt6WsarzUI6jydE/tPEpICaAWTik9NG2Ux/ZD0LdX3dPykIVFt0vl7Sb2f2tWSU2yGn2oQkRfVdTq29BSb4wDQBl5O1mtaKwcXKQtrrXGYqc62Dr2+4lOU9Z5MUtZ7ukzHp0JOAK0S5bTV4IwuHW+UH6SZmMwXUnZGvSGu6ZSscxXXPK1C1eSEqAD+P2ID23pJJpmdpmsiS0mp6ocop74wxgVVPrpZWaOL5ATQHqVpnS24tEWXsQEer51waFpXW6/wqhzPfGxjWgfQJrWe00uqV+U1TlFadv2spQQ+JdmNTErPymsV9ho3vXhaB9Amc57WPWv8dM4nqmJ6Gr1bl5YT+J7SmXID/EqscwKAMsfWOT2l8qJap/N2kvZ3tzeWpCTVk5PdxAxo0umVIxsrxAFAGveofXqKK8RtireRk5LmTOvubm/6+4dHKXfd35QlYx34rYYb8G4dAHhieqq9W3dUTFK9IW438MeWmmwNQ2n5AP0mgDbx6ckLqrYrge879bO2TAnpyfDTvK3YzwkAyvQaC8okZf6I+zkVU5MkdsIEgD9CFIkXlBdV/Py+nTAN9hAHgA/QF8ZSfWwPcQ//vgIAH8DLZSSs3/73lQj/WwcAR6gKZY6QPO+SEwDA32IhAIBPCHICgE/JT3v2qqimDDyeAAAAAElFTkSuQmCC"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-4",
  d: "M444 452.79H174.87c-.52 0-.93 1.51-.93 3.31v-.62c0 1.86.43 3.31.93 3.31H444c.53 0 .93-1.51.93-3.31v.62c0-1.8-.4-3.31-.93-3.31z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("image", {
  className: "develop-quickly_svg__cls-3",
  width: 154,
  height: 29,
  transform: "translate(303.08 277.09)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAAAeCAYAAAA7HGznAAAACXBIWXMAAAsSAAALEgHS3X78AAADK0lEQVR4Xu2b23HbMBBFL/WwHNkpzk24BdegFtSEmkuit+gP4gqXS4CUnIwmoPfMYEDxIXzwzO4CJKu6ruE4j2AydILj/CtmQycoq/Wm6jncd8wpl2zq+3h/uystVrekUZGsQlcql+z7oLLU2t8iXq9sCclsg9l2xkmd6FOtV7qsbEE0ton0E/ltxSMuX/lYMSjURfrUdla4pGwimso1Ne0W6Zzy0chFqc6hP8n2Wc5JCteZICREm4bzZgDmpqd0qdTqlI1NmRTqjEayY2in0BCOVXJti9xslLJN0Yg1B7AA8CQ99+eEc8rHikbJDqHtQ2/v+WW13nSiW0u2RJ3GKLYA8EPaM6J0GuF03c6lKxeNakydFG0PYAdgi+a+M5JdpCWjWyqy2RQ6RyPXEsALgNewTemYUrWGc8rHRjWKtgXwB/GeW9E4UegIl5MtF9leAfwM7SXsW6BbvwEuXclQEo1qB0TR5mjuL48x6rWCzWq9qTSVXmWTFAq0o9sMsVazwi3Dfo1uLlv5qGys1faIgQWIAu7RLaWS974vsukkgemU0j2jEW8Ztp/kPJetfKxsRzSuVOH3Ad2anbIB0Z/BNKpY8eya28w0nZXa/3H+b2xBz1qM0pzRXWNNRbLsvR6SjQPaBT1dbzkhFooe2cZBKo1yAZeLuHZCYK/tkJJNZyEaRpmfOe3ltQyrnkbHQ65m24a2Q1xjsxLy+vzSx8f7W71ab/REhk4WgjvEKS9nIszdqbU2l61chmajv0K/Q1u4VKS7kkujajTXV1iTAXFwWyRqjeeUzdA622/EKHdAlO0qWu8ThEBqEBaBjHa0nI+t7CMrwIUrmVp6jW72CYLKdkRbuHwaBTqplANQGu7jgPps1KPaOLGBJ/dsdFA0IJ9GOUCFZgCt4TStpl41Aly4MaDRTYXLvfWhdVt90ytGEt2A5mIdjIPoeksFj2pjRieMukJBH86yLxvVANz8pm6F7iKeFU1x6crHiqHCqXh2+743dckd3yBo74yPOtGn2te+QVCMdNrbbWfcqCwtAf/666oU/u3otyMryC2CKXfL5jhfZQLHeRAum/MwPgFOEKx5C8p1IAAAAABJRU5ErkJggg=="
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-5",
  d: "M595.13 452.79H466c-.52 0-.93 1.51-.93 3.31v-.62c0 1.86.43 3.31.93 3.31h129.13c.52 0 .93-1.51.93-3.31v.62c0-1.8-.41-3.31-.93-3.31z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("g", {
  id: "develop-quickly_svg__Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "develop-quickly_svg__Group-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M413.86 136.7v192.81m45.16-192.81v192.81m-227-192.81v192.81m45.2-192.81v192.81m46.3-192.81v192.81m45.2-192.81v192.81m124.14-113.88h-291m291 45.2h-291m291 46.3h-291m291-136.6h-291",
  stroke: "#111",
  strokeLinecap: "square",
  strokeOpacity: 0.05,
  strokeWidth: 1.13,
  fill: "none",
  id: "develop-quickly_svg__Line-2"
}))), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-7",
  d: "M481.55 403.39h115.59c1.55 0 2.76 2 2.76 4.39v41.51c0 2.46-1.26 4.39-2.76 4.39H481.55c-1.55 0-2.76-2-2.76-4.39v-41.51c0-2.39 1.21-4.39 2.76-4.39z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.38 319.77h48.78c.75 0 1.34 1.16 1.34 2.54v24c0 1.42-.61 2.54-1.34 2.54h-48.78c-.74 0-1.33-1.16-1.33-2.54v-24c0-1.38.59-2.54 1.33-2.54z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-5",
  d: "M233.38 340a8.3 8.3 0 00-.84-10.9l-15.1-14.83a7.64 7.64 0 00-11.43.83 7.64 7.64 0 002.43 11.35z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.64 327a8 8 0 0010.29-3.28l44.66-55.63-15.67-27.29-43.3 76.2a8 8 0 004.02 10z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-5",
  cx: 61.88,
  cy: 157.46,
  r: 4.28
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-5",
  d: "M287.05 338.67a8.31 8.31 0 012.59-10.62l17.3-12.2a7.64 7.64 0 0111.14 2.65 7.65 7.65 0 01-4.23 10.82z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.43 329.52a8 8 0 01-10.12-3.77l-41.26-57.65L279 241l39.88 78.66a7.94 7.94 0 01-4.45 9.86z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-2)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-5",
  cx: 161.25,
  cy: 159.82,
  r: 4.28
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-5",
  d: "M106.12 13.17h13.81v44.39h-13.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.12 57.56h13.81",
  stroke: "#3fb984",
  strokeWidth: 1.33,
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#develop-quickly_svg__linear-gradient-3)",
  d: "M96.6 60.76l16.41-8.46 16.56 8.46v19.69H96.6V60.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.54 77.16h29.08v30.61a7.16 7.16 0 01-7.16 7.16H105.7a7.16 7.16 0 01-7.16-7.16V77.16z",
  fill: "url(#develop-quickly_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-7",
  d: "M91.7 72.99h42.64v12.78H91.7z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-5)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 51.42h13.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-6)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 46.72h13.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-7)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 42.03h13.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-8)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 37.33h13.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-9)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 32.64h13.81"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#develop-quickly_svg__linear-gradient-10)",
  strokeMiterlimit: 10,
  fill: "none",
  d: "M106.12 27.94h13.81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252 169.53a13 13 0 005 17l220.8 122.75 32.2-37.21L268.62 163.3a13 13 0 00-16.62 6.23z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-11)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-5",
  cx: 113.58,
  cy: 13.05,
  r: 7.04
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-7",
  d: "M445.48 255.09H507v39.15a15.15 15.15 0 01-15.15 15.15h-31.22a15.15 15.15 0 01-15.15-15.15v-39.15z",
  transform: "rotate(115.54 452.355 153.76)"
}), /*#__PURE__*/React.createElement("g", {
  id: "develop-quickly_svg__Group-88"
}, /*#__PURE__*/React.createElement("path", {
  d: "M441.85 223a10.11 10.11 0 00-5.46-1 29.32 29.32 0 00-10.66 3.1c-3.14 1.55-5.37 2.95-5.57 3-9.09.83 13.09 10.3 13.09 10.3l26.95 11.46.85 3s-4.94-22.29-19.2-29.74z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-3)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.91 247.75c.32-6-2.7-30-13-29.52a6.89 6.89 0 00-2 .39c-11.93 4 4.11 28.14 4.11 28.14s-3.52 11.78-14.02 17.67c-4.63 2.57-4.41 11.57-4.41 11.57l3.77-3 .7 6.47 3.42-4 4 5.32 1.49-11s15.17-9.72 15.89-22.07z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-4)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.17 212.11c2-7.74-7.23-2.87-9.26-13a14.78 14.78 0 00-2.56 10.44c.77 4.56-.8 8 1.44 11.28 2 3.11 6 1.84 7.55.11 2.54-3 2.09-5.83 2.83-8.85z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-5)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.78 205.54c-8.17-7.91-18.63-7.42-24.37-3.95a10.71 10.71 0 00-3.18 2.85c-1.77 2.48-6 9.15-6.47 11.52-.39 1.87-.14 3.82 1.94 6.3-.4 1.07-1.52 4.43.91 5.18a11.62 11.62 0 001 2.43c-.25 3.07 5.12 7.3 6 7.46 7.08 1.08 33.26-10.9 24.79-21.43-5.74-7.17 2.64-7.21-.66-10.36z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-6)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-25",
  d: "M408.37 227.43l-1.16 1.68a1.86 1.86 0 01-.16-.42 7.53 7.53 0 00-.39-1.16.46.46 0 01.23 0c.31-.08.76-.11 1.14-.23l.09-.05a.2.2 0 01.27.06s.06.07-.02.12zm2.52 2.44c.26-.15.29-.29.24-.37l-1.81-2.41h-.08c-.24.38-1.16 1.75-1.52 2.32h-.09a.35.35 0 00.24.2 21.59 21.59 0 003 .16zm1.01-.26c.06.09.14 0 .17-.1l1.6-3.54a.1.1 0 000-.14.23.23 0 00-.28-.06l-2 .52c-.31.07-.7.19-1.1.31l-.08.05c-.17.11-.21.24-.15.33l1.82 2.63zm3.9-.13l.17-.1c.17-.11.2-.24.15-.33l-1.79-2.77-.09.05-1.41 3.07v.14c0 .14.1.17.24.21.8 0 1.78-.15 2.76-.27zm1.95-4.11l-.05-.08c-.05-.09-.15-.26-.29-.29-.45 0-.84.16-1.29.19a6.47 6.47 0 00-1.28.19l-.09.06c-.17.1-.2.24-.15.32l2 3.2c.05.09.05.09.14 0zm2.72 3.15v-.14a.22.22 0 00.07-.27l-2.31-2.46h-.09l-.86 3.21.05.08c.05.09.11.17.33.16 1.06-.18 1.93-.47 2.77-.63zm.86-.52c.05.09.14 0 .12-.19l.91-3.12c.09-.05-.05-.09-.18-.12-.45 0-.81 0-1.26.05-.67.06-1.33.11-2.09.22h-.08a.21.21 0 00-.07.27l2.65 2.84zm3.94-1.21c.17-.11.21-.24 0-.36-.49-.41-1.83-1.47-2.21-1.71l-.08.05-.85 2.85a.1.1 0 000 .14c0 .14.15.26.32.15a30.27 30.27 0 002.83-1.12zm.73-2.44c0-.14-.11-.17-.24-.21-.18.11-.31.07-.4.13a9.87 9.87 0 00-1.2.14l-.17.1-.09.05c-.08.05 0 .14 0 .22l1.91 1.42h.09l.08-1.8zm1.92.83l-.05-.08-1.1-.86h-.09v1.67c-.09 0 .05.08.14 0a6.54 6.54 0 001.14-.81zm.87-.88a2.44 2.44 0 00.94-1.73c-.05-.09 0-.22-.07-.31l-.08.05a3.82 3.82 0 01-.79.83 11.47 11.47 0 01-1.56.71v.08l1.05.77h.09c.17-.11.2-.24.37-.35z",
  transform: "translate(-150.14 -162.3)",
  id: "develop-quickly_svg__Group-55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.35 199.61a11.14 11.14 0 00-2.72 1.3l-.52.31a5.45 5.45 0 00-1.59 2c-1.29 3.47 1.37 13.66 7 15.86a11.26 11.26 0 005.15-1.72l-1.77-2.55 3.43.84a11.61 11.61 0 002.07-5.46l-2.4-1.09 2.57-1a7.92 7.92 0 00-.08-1.48c-.46-4.63 1.29-9.07 1.63-11 .05-.5.28-2 .38-2.45a.92.92 0 00-.4-1 .91.91 0 00-.72 0l-.42.26a27.16 27.16 0 01-11.62 7.26z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-7)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450.13 195.62a15.3 15.3 0 01.52-2.42 27.81 27.81 0 01-5.58 7 33 33 0 01-3.95 2.74l-.6.36-.09.06c-3.8 2.41-4 4.4-4.28 5.86-.51 2.64 1.58 6.29 3 9 .16.25.23.56.44.91a9.48 9.48 0 005.15-1.72l-1.77-2.55 3.43.84a11.61 11.61 0 002.07-5.46L446 209.1l2.57-1a7.92 7.92 0 00-.08-1.48c-.46-4.63 1.29-9.07 1.63-11z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-12)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.05 204.75c-.43.25-.61.72-.23 1a2.5 2.5 0 002.17-.27c.86-.52.94-1.15.43-1.42a6.84 6.84 0 00-2.37.73z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-13)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.21 206.11h-.08c-.77.46.11 1.34.77 1.28.72 0 1.56-.71 1.3-1.14-.26-.42-1.42-.42-2-.19z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-14)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.94 202.7a.81.81 0 00-.39.12 2.39 2.39 0 00-1.07 1.7c.08.54.72.62 2.09.37 1.51-.21 2.45-1.36 2.33-1.75-.13-.4-2.2-.55-3-.44z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-15)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  id: "develop-quickly_svg__Group-87"
}, /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-31",
  d: "M421.58 215.46a13.84 13.84 0 014.08-2.7 6.88 6.88 0 012.37-.15s-.81-1.73-2.18-1.48c-2.3.45-4.52 3.55-8.47 6.29-1.49 1-2.51 1.64-2.51 1.64a5.11 5.11 0 001.88 0z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-73",
  className: "develop-quickly_svg__cls-32",
  d: "M416.8 219.17a5.08 5.08 0 005.19 1.42 5.06 5.06 0 003.65-6.53 13.54 13.54 0 00-4.06 1.4z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-75",
  className: "develop-quickly_svg__cls-33",
  d: "M420.36 217.13a9.39 9.39 0 00-2.24 1.71 3.07 3.07 0 005.31-2.05 3.35 3.35 0 00-.12-1 9.45 9.45 0 00-2.95 1.31z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-77",
  className: "develop-quickly_svg__cls-31",
  d: "M410.7 220.29c.57-.23 1.44-.52 1.3-.55s-1-.19-2-.43c-2.53-.69-4.49-2.19-5.67-1.83-.65.28-.49 1.7-.49 1.7a2.44 2.44 0 011.08-.53 5.74 5.74 0 012.69.59z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-79",
  className: "develop-quickly_svg__cls-32",
  d: "M407.66 219.32a5.61 5.61 0 00-2.22.18l.36 1.18c.47 1.36 1.64 2.52 3.18 2.17a2.6 2.6 0 001.91-2.44z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-81",
  className: "develop-quickly_svg__cls-33",
  d: "M408.68 220.23c1.05.18 1.42.42 1.29.39a1.51 1.51 0 01-1.11 1.25c-.79.25-1.43-.42-1.7-1.07 0-.22-.13-.39-.14-.62a4.54 4.54 0 011.66 0z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__Fill-85",
  className: "develop-quickly_svg__cls-25",
  d: "M408.73 220.31c-.86-.06-1.06.18-.65.28s1.94.7 1.77.22-1.12-.5-1.12-.5z",
  transform: "translate(-150.14 -162.3)"
}))), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-7",
  d: "M573.24 249.53V448a5.7 5.7 0 01-5.7 5.7h-53.9a5.7 5.7 0 01-5.7-5.7V249.53a5.7 5.7 0 015.7-5.7h53.9a5.7 5.7 0 015.7 5.7z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.24 249.53V448a5.7 5.7 0 01-5.7 5.7h-53.9a5.7 5.7 0 01-5.7-5.7V249.53a5.7 5.7 0 015.7-5.7h53.9a5.7 5.7 0 015.7 5.7z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_6-8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "develop-quickly_svg__path10351",
  className: "develop-quickly_svg__cls-4",
  d: "M544.06 284.07c-.07 0-.14 0-.14-.07s-.15-.07-.3-.07a3.28 3.28 0 00-.88-.08 1 1 0 01-.44-.07h-.08a15.6 15.6 0 01-2.5-.44 1 1 0 01-.52-.52l-.59-.15a19.12 19.12 0 00-.29-6.48 20 20 0 00-2.58-6l.44-.44v-.08a1 1 0 01.23-.66 12.7 12.7 0 012.06-1.47l.44-.22c.29-.15.51-.3.81-.45.07-.07.15-.07.22-.14s0-.08 0-.15a1.44 1.44 0 00.29-2.06 1.39 1.39 0 00-1-.52 1.77 1.77 0 00-1 .37l-.07.07c-.07.08-.15.15-.22.15a5 5 0 00-.59.66c-.07.15-.22.22-.3.3a9.22 9.22 0 01-1.84 1.62 1 1 0 01-.44.15.4.4 0 01-.29-.08h-.08l-.59.37c-.58-.59-1.25-1.18-1.84-1.77a18.91 18.91 0 00-9.57-3.83l-.07-.58v.07a1 1 0 01-.37-.59 14.39 14.39 0 01.15-2.5v-.08c0-.14.07-.29.07-.44s.07-.59.15-.88v-.44A1.46 1.46 0 00521 255a1.5 1.5 0 00-1.25.51 1.47 1.47 0 00-.45 1v.36a4 4 0 00.15.89 1 1 0 01.07.44v.07a13.66 13.66 0 01.15 2.51 1 1 0 01-.37.59v.14l-.07.59c-.81.08-1.62.22-2.5.37a17.63 17.63 0 00-9.06 5.15l-.44-.29h-.08c-.07 0-.14.07-.29.07a1.08 1.08 0 01-.44-.14 13.68 13.68 0 01-1.84-1.7 1 1 0 00-.3-.29c-.22-.22-.36-.44-.59-.67-.07-.07-.14-.07-.22-.14l-.07-.08a1.74 1.74 0 00-1-.36 1.11 1.11 0 00-1 .51 1.58 1.58 0 00.29 2.06.08.08 0 01.08.08s.14.14.22.14a7.35 7.35 0 00.81.45l.44.22a10.24 10.24 0 012.06 1.47.74.74 0 01.22.66v-.07l.44.44c-.07.15-.14.22-.22.37a17.45 17.45 0 00-2.57 12.07l-.59.15c0 .07-.08.07-.08.07a1.16 1.16 0 01-.51.52 13.42 13.42 0 01-2.51.44 1 1 0 00-.44.07c-.29 0-.59.08-.88.08-.08 0-.15.07-.3.07s-.07 0-.14.08a1.43 1.43 0 00-1.18 1.69 1.37 1.37 0 001.47 1 .7.7 0 00.37-.07c.07 0 .07 0 .07-.08s.22 0 .3 0c.29-.07.59-.22.81-.29a.93.93 0 01.44-.15 13.8 13.8 0 012.43-.66h.08a.83.83 0 01.59.22.07.07 0 01.07.07l.66-.07a17.8 17.8 0 006 8.61 11.32 11.32 0 002 1.33l-.37.51a.07.07 0 00.07.08.86.86 0 01.08.73 12.38 12.38 0 01-1.18 2.14v.07a1.39 1.39 0 01-.3.37c-.14.15-.29.44-.51.74-.08.07-.08.14-.15.22a.07.07 0 01-.07.07 1.51 1.51 0 00.59 2 1.36 1.36 0 00.51.15 1.64 1.64 0 001.4-.89.07.07 0 01.07-.07c0-.07.08-.15.15-.22.08-.3.22-.52.3-.81l.14-.44a12.46 12.46 0 011-2.29 1.2 1.2 0 01.59-.44c.07 0 .07 0 .07-.07l.3-.59a17.29 17.29 0 006.4 1.18 14.71 14.71 0 004-.52 20.89 20.89 0 002.36-.66l.29.52c.07 0 .07 0 .07.07a1.11 1.11 0 01.59.44 12.36 12.36 0 011 2.28v.08l.15.44a2.51 2.51 0 00.29.81c.08.07.08.15.15.22a.07.07 0 00.07.07 1.65 1.65 0 001.4.89 1.83 1.83 0 00.59-.15 1.23 1.23 0 00.66-.81 1.8 1.8 0 00-.07-1.1.07.07 0 00-.07-.08c0-.07-.08-.15-.15-.22a3 3 0 00-.52-.74 1.15 1.15 0 00-.29-.36V299a8.34 8.34 0 01-1.18-2.14.9.9 0 01.07-.73.08.08 0 01.08-.08l-.22-.58a18.27 18.27 0 008-10l.59.08c.07 0 .07-.08.07-.08a.83.83 0 01.59-.22h.07a13.05 13.05 0 012.36.66h.07a1 1 0 00.45.15 3.45 3.45 0 00.81.37c.07 0 .14.07.29.07s.07 0 .15.08a.68.68 0 00.37.07 1.6 1.6 0 001.47-1 1.75 1.75 0 00-1.33-1.55zm-21.28-2.28l-2 1-2-1-.52-2.13 1.4-1.77h2.21l1.4 1.77zm12-4.79a14.27 14.27 0 01.29 4.64l-7-2a1.21 1.21 0 01-.89-1.48 1.17 1.17 0 01.3-.51l5.52-5a15.14 15.14 0 011.79 4.35zm-4-7.06l-6 4.27a1.25 1.25 0 01-1.62-.3.65.65 0 01-.22-.51l-.44-7.44a13.87 13.87 0 018.32 4zm-13.33-3.76l1.48-.29-.37 7.36a1.23 1.23 0 01-1.25 1.18 1.77 1.77 0 01-.59-.15l-6.11-4.34a14.63 14.63 0 016.87-3.76zm-9 6.48l5.45 4.86a1.19 1.19 0 01.15 1.69.84.84 0 01-.59.37l-7.15 2.06a15.5 15.5 0 012.19-8.98zm-1.25 12.44l7.29-1.25a1.2 1.2 0 011.25 1 .92.92 0 01-.07.74l-2.8 6.77a14.44 14.44 0 01-5.62-7.26zm16.8 9.13a14.93 14.93 0 01-3.16.37 16.53 16.53 0 01-4.64-.73l3.61-6.56a1.13 1.13 0 011.47-.29 3.83 3.83 0 01.59.51l3.53 6.41a13 13 0 00-1.4.29zm9-6.4a14.2 14.2 0 01-4.41 4.42l-2.87-6.93a1.18 1.18 0 01.66-1.39 2 2 0 01.66-.15l7.36 1.25a10.79 10.79 0 01-1.46 2.8z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-5",
  d: "M506 314.56h29.92a5.16 5.16 0 015.2 5.2v66.63a5.16 5.16 0 01-5.2 5.2H506a5.16 5.16 0 01-5.2-5.2v-66.63a5.23 5.23 0 015.2-5.2z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "develop-quickly_svg__cls-7",
  d: "M515.67 314.56H536a5 5 0 015 5v67a5 5 0 01-5 5h-20.33a5 5 0 01-5-5v-67a5.15 5.15 0 015-5z",
  transform: "translate(-150.14 -162.3)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 376.68,
  cy: 170.36,
  r: 7.4,
  fill: "url(#develop-quickly_svg__radial-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-36",
  cx: 376.68,
  cy: 170.36,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 376.68,
  cy: 190.43,
  r: 7.4,
  fill: "url(#develop-quickly_svg__radial-gradient-2)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-36",
  cx: 376.68,
  cy: 190.43,
  r: 4.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 376.68,
  cy: 210.49,
  r: 7.4,
  fill: "url(#develop-quickly_svg__radial-gradient-3)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "develop-quickly_svg__cls-36",
  cx: 376.68,
  cy: 210.49,
  r: 4.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.55 403.39h115.59c1.55 0 2.76 2 2.76 4.39v41.51c0 2.46-1.26 4.39-2.76 4.39H461.55c-1.55 0-2.76-2-2.76-4.39v-41.51c0-2.39 1.21-4.39 2.76-4.39z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.32 375v22.25a3.41 3.41 0 01-3.41 3.41h-44.34a3.41 3.41 0 01-3.41-3.41V375a3.41 3.41 0 013.41-3.41h44.34a3.41 3.41 0 013.41 3.41z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 403.14v22.25a3.41 3.41 0 01-3.41 3.41h-85.72a3.41 3.41 0 01-3.41-3.41v-22.25a3.41 3.41 0 013.41-3.41h85.74a3.41 3.41 0 013.39 3.41z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.2 375v22.25a3.41 3.41 0 01-3.41 3.41h-104a3.41 3.41 0 01-3.41-3.41V375a3.41 3.41 0 013.41-3.41h104a3.41 3.41 0 013.41 3.41z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-19)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.21 403.14v22.25a3.41 3.41 0 01-3.41 3.41H176.53a3.41 3.41 0 01-3.41-3.41v-22.25a3.41 3.41 0 013.41-3.41H345.8a3.41 3.41 0 013.41 3.41z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__linear-gradient-20)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452 428v22.25a3.41 3.41 0 01-3.41 3.41H170.82a3.41 3.41 0 01-3.41-3.41V428a3.41 3.41 0 013.41-3.41h277.79A3.41 3.41 0 01452 428z",
  transform: "translate(-150.14 -162.3)",
  fill: "url(#develop-quickly_svg__New_Gradient_Swatch_7)"
}));

function SvgDevelopQuickly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 493.37 330.07"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref2));
}

export default __webpack_public_path__ + "static/develop-quickly.f06e6cef.svg";
export { SvgDevelopQuickly as ReactComponent };